// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RenameAudioModal-module__actions--ElFjF{display:flex;justify-content:flex-end;gap:var(--vp-space-2);flex-wrap:wrap;margin-top:var(--vp-space-4)}`, "",{"version":3,"sources":["webpack://./src/shared/ui/RenameAudioModal/RenameAudioModal.module.scss"],"names":[],"mappings":"AAAA,yCACE,YAAA,CACA,wBAAA,CACA,qBAAA,CACA,cAAA,CACA,4BAAA","sourcesContent":[".actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--vp-space-2);\n  flex-wrap: wrap;\n  margin-top: var(--vp-space-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": `RenameAudioModal-module__actions--ElFjF`
};
export default ___CSS_LOADER_EXPORT___;
